import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import ValidationResults from './ValidationResults';

const PublishControls = ({
    title,
    description,
    scope,
    scopeLabel,
    draftConfig,
    validating,
    onValidate,
    onPublish,
    validation,
    showAllWarnings,
    onToggleWarnings,
    children
}) => (
    <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={2}>
            <Box>
                <Typography variant="h6">{title}</Typography>
                <Typography variant="body2" color="text.secondary">{description}</Typography>
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                {children}
                <Button variant="outlined" onClick={onValidate} disabled={validating || !draftConfig}>
                    {validating ? 'Validating...' : 'Validate Draft'}
                </Button>
                <Button variant="contained" onClick={() => onPublish(scope)} disabled={!draftConfig}>
                    Publish {scopeLabel} Draft
                </Button>
            </Stack>
            <ValidationResults
                validation={validation}
                showAllWarnings={showAllWarnings}
                onToggleWarnings={onToggleWarnings}
            />
        </Stack>
    </Paper>
);

export default PublishControls;
